<template>
  <MainChatBox />
</template>

<script>
// @ is an alias to /src
import MainChatBox from '@/components/MainChatBox.vue'

export default {
  name: 'home',
  components: {
    MainChatBox
  }
}
</script>
